var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('h1',[_vm._v("This is an about page")]),_c('div',[_vm._v("url = "+_vm._s(_vm.url))]),_c('div',[_vm._v(_vm._s(_vm.all))]),_c('div')])}
var staticRenderFns = []

export { render, staticRenderFns }